<!-- 文字配置 -->
<template>
    <div class="flex font-set">
        <el-color-picker
            size="small"
            show-alpha
            v-model="color"
            class="font-set-color"
            style="margin-right: 6px"
            v-if="renderType.includes('color')"
        />
        <el-input-number
            size="small" 
            class="font-set-size"
            v-model="size"
            :controls="false"
            v-if="renderType.includes('size')"
        ></el-input-number>
        <span class="unit">px</span>
        <el-button
            :class="['font-set-btn', isBold ? 'active' : '']"
            type="primary"
            link
            @click="handleBoldClick"
            v-if="renderType.includes('isBold')"
        >B</el-button>
        <el-button
            :class="['font-set-btn italic', isItalic && 'active']"
            type="primary"
            link
            @click="handleItalicClick"
            v-if="renderType.includes('isItalic')"
        >I</el-button>
        <el-button
            class="font-set-btn"
            type="primary"
            link
            @click="_ => align = 'left'"
            v-if="renderType.includes('align')"
        >
            <svg t="1724808925877" :fill="align === 'left' ? '#3e7aff' : '#3e3e3e'" class="icon" viewBox="0 0 1024 1024" version="1.1" xmlns="http://www.w3.org/2000/svg" p-id="1610"><path d="M96 128h832v96H96zM96 576h832v96H96zM96 352h576v96H96zM96 800h576v96H96z" p-id="1611"></path></svg>
        </el-button>
        <el-button
            class="font-set-btn"
            type="primary"
            link
            @click="_ => align = 'center'"
            v-if="renderType.includes('align')"
        >
            <svg t="1724808808086" :fill="align === 'center' ? '#3e7aff' : '#3e3e3e'"  class="icon" viewBox="0 0 1024 1024" version="1.1" xmlns="http://www.w3.org/2000/svg" p-id="1463"><path d="M96 128h832v96H96zM96 576h832v96H96zM224 352h576v96H224zM224 800h576v96H224z" p-id="1464"></path></svg>
        </el-button>
        <el-button
            class="font-set-btn"
            type="primary"
            link
            @click="_ => align = 'right'"
            v-if="renderType.includes('align')"
        >
            <svg t="1724808958824" :fill="align === 'right' ? '#3e7aff' : '#3e3e3e'" class="icon" viewBox="0 0 1024 1024" version="1.1" xmlns="http://www.w3.org/2000/svg" p-id="1757"><path d="M96 128h832v96H96zM96 576h832v96H96zM352 352h576v96H352zM352 800h576v96H352z" p-id="1758"></path></svg>
        </el-button>
    </div>
</template>
  
<script>

export default {
    name: "fontSet",
    data() {
        return {
            color: this.modelValue?.color,
            size: this.modelValue?.size,
            align: this.modelValue?.align,
            isBold: this.modelValue?.isBold === 'bold',
            isItalic: this.modelValue?.isItalic === 'italic',
        };
    },
    props: {
        renderType: {
            type: String,
            default: 'color, size, isBold, isItalic, align',
        },
        modelValue: {
            type: Object,
            default: () => {
                return {
                    color: '',
                    size: '',
                    align: '',
                    isBold: '',
                    isItalic: '',
                }
            }
        },
    },
    watch: {
        color(val) {
            this.$emit('update:modelValue', {
                ...this.modelValue,
                color: val,
            })
        },
        size(val) {
            this.$emit('update:modelValue', {
                ...this.modelValue,
                size: val,
            })
        },
        align(val) {
            this.$emit('update:modelValue', {
                ...this.modelValue,
                align: val,
            })
        }
    },
    components: {
    },
    mounted() {
    },
    methods: {
        handleBoldClick() {
            this.isBold = !this.isBold
            this.$emit('update:modelValue', {
                ...this.modelValue,
                isBold: this.isBold ? 'bold' : 'normal',
            })
        },
        handleItalicClick() {
            this.isItalic = !this.isItalic
            this.$emit('update:modelValue', {
                ...this.modelValue,
                isItalic: this.isItalic ? 'italic' : 'normal',
            })
        }
    }
};
</script>
  
<style lang="scss" scoped>
.font-set-size {
    width: 32px !important;
    :deep(.el-input__wrapper) {
        padding: 1px 6px !important;
    }
}
.font-set-color {
    margin-right: 6px;
}
.font-set {
    :deep(.el-color-picker) {
        margin-right: 6px;
    }
    :deep(.el-button+.el-button) {
        margin-left: 3px;
    }
}
.font-set-btn {
    font-weight: 900;
    color: #3e3e3e;
    font-size: 16px;
    svg{
        width: 16px;
        height: 16px;
        margin: 0;
    }
    margin: 0 0px;
}
.font-set-btn:hover {
    color: #3e3e3e;
}
.font-set-btn:visited {
    color: #3e3e3e;
}
.font-set-btn:focus{
    color: #3e3e3e;
}

.font-set-btn.active {
    color: #3e7aff;
}
.italic {
    font-style: italic;
}
.unit {
    font-size: 13px;
    padding-left: 4px;
    padding-right: 4px;
}
</style>